import { render, staticRenderFns } from "./DocumentosId.vue?vue&type=template&id=e3817452&"
import script from "./documentosId.ts?vue&type=script&lang=ts&"
export * from "./documentosId.ts?vue&type=script&lang=ts&"
import style0 from "./DocumentosId.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports